// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Ag","hasBadge":"e_Bg","bottomLine":"e_Cg","imageContainer":"e_Dg","image":"e_Eg","header":"e_Fg","title":"e_Gg","score":"e_Hg"};